import { AxiosResponse } from 'axios';
import axios from '../utils/axios';
import { ResponseDataInterface } from '../types';

export const createPersonalAppointment = (
  patientServicePackageId: string
): Promise<AxiosResponse<ResponseDataInterface<any>>> =>
  axios.post(`/api/v1/appointments/personal`, { patientServicePackageId });
